module.exports = __webpack_public_path__ + "static/media/vip-icon.930ef848.png";